import { useState, useEffect } from "preact/compat";
import { createPortal } from "preact/compat";

import useWeightModal from "@/hooks/useWeightModal";
import CloseIcon from "@/icons/CloseIcon";
import AddToCartButton from "@/components/AddToCartButton";
import { formatter } from "@/Utils";

function WeightModal() {
	const { modalRef, toggleModal, closeModal, modalProduct } = useWeightModal();
	const [activeWeight, setActiveWeight] = useState({});
	const target = document.querySelector(".weight-modal-root");

	useEffect(() => {
		if (!modalProduct.variants) {
			return;
		}

		setActiveWeight(modalProduct.variants[0]);
	}, [modalProduct]);

	useEffect(() => {
		if ( ! modalRef.current ) {
			return;
		}
		
		modalRef.current.addEventListener("click", handleOutsideClick);

		return () => {
			modalRef.current.removeEventListener("click", handleOutsideClick);
		};
	}, []);

	function handleOutsideClick(event) {
		const isInsideModal = modalRef.current.contains(event.target);

		if (!isInsideModal) {
			closeModal();
		}

		if (event.type === "keydown" && event.key === " ") {
			if (isInsideModal) {
				event.preventDefault();
			}
		}
	}

	function handleDialogClick(event) {
		if (event.target === modalRef.current) {
			closeModal();
		}
	}

	if (!target) {
		return null;
	}

	return createPortal(
		<dialog className="weight-modal" ref={modalRef} onClick={handleDialogClick}>
			<div className="weight-modal-content">
				<form className="weight-modal-header" method="dialog">
					<p>Select weight</p>
					<button className="btn-reset" onClick={() => toggleModal()}>
						<CloseIcon color="#fff" />
					</button>
				</form>
				{modalProduct.variants ? (
					<div className="product-card-price-options">
						{modalProduct.variants.map((variant) => (
							<button
							onClick={() => setActiveWeight(variant)}
							className={`btn-sm btn-white-outline ${activeWeight.id == variant.id ? "active" : ""}`}
							key={variant.id}
							aria-label="Select weight"
							>
								<span>{variant.option}</span> - 
								<span className="product-price-slideout">
									{variant.specialPriceRec ? (
										<>{formatter(variant.specialPriceRec)} <strike>{formatter(variant.priceRec)}</strike></>
									) : (
										<>{formatter(variant.priceRec)}</>
									)}
								</span>
							</button>
						))}
					</div>
				) : null}

				<AddToCartButton 
				product={modalProduct} 
				quantity={1}
				weight={activeWeight} 
				classes="btn-sm btn-white-outline" 
				onFinish={closeModal} 
				category={modalProduct.category}
				>
					<AddToCartButton.Label>Add To Cart</AddToCartButton.Label>
				</AddToCartButton>
			</div>
		</dialog>,
		target
	);
}
export default WeightModal;